import { useHistory as useHistoryReactRouter } from 'react-router-dom'

const useHistory = (...rest) => useHistoryReactRouter(...rest)

export default useHistory
